import { render } from "./BudgetItem.vue?vue&type=template&id=f8bc4c48&ts=true"
import script from "./BudgetItem.vue?vue&type=script&lang=ts"
export * from "./BudgetItem.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/mmwapp/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__